import React from 'react';
import { Box } from '@mui/material';
import {
  Assessment as AssessmentIcon,
  MonetizationOn as MonetizationOnIcon,
  CheckCircle as CheckCircleIcon,
  Schedule as ScheduleIcon,
  PlayArrow as PlayArrowIcon,
} from '@mui/icons-material';
import MetricCard from './MetricCard';

const OverviewMetrics = ({ overviewData, templatePerformance }) => {
  if (!overviewData) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        mb: 3,
        flexWrap: { xs: 'wrap', md: 'nowrap' },
        '& > *': {
          flex: '1 1 0',
          minWidth: 0,
        },
      }}
    >
      <MetricCard
        title="Template Overview"
        value={overviewData.total_templates}
        subtitle={`${overviewData.active_templates} executed • ${overviewData.status_counts?.active || 0} active • ${overviewData.status_counts?.draft || 0} draft`}
        icon={<AssessmentIcon sx={{ fontSize: 36 }} />}
        color="primary"
      />
      <MetricCard
        title="Completed Executions"
        value={overviewData.completed_executions.toLocaleString()}
        subtitle={overviewData.period}
        icon={<PlayArrowIcon sx={{ fontSize: 36 }} />}
        color="success"
      />
      <MetricCard
        title="Total Cost"
        value={`$${(overviewData.total_cost || 0).toFixed(2)}`}
        subtitle={overviewData.period}
        icon={<MonetizationOnIcon sx={{ fontSize: 36 }} />}
        color="warning"
      />
      <MetricCard
        title="Success Rate"
        value={`${(overviewData.success_rate || 0).toFixed(1)}%`}
        subtitle={overviewData.period}
        icon={<CheckCircleIcon sx={{ fontSize: 36 }} />}
        color="info"
      />
      <MetricCard
        title="Avg Execution Time"
        value={(() => {
          if (overviewData?.average_execution_time != null) {
            return `${Number(overviewData.average_execution_time).toFixed(2)}s`;
          }
          if (templatePerformance?.templates?.length > 0) {
            const avg =
              templatePerformance.templates.reduce(
                (sum, t) => sum + (t.average_execution_time || 0),
                0
              ) / templatePerformance.templates.length;
            return `${avg.toFixed(2)}s`;
          }
          return 'N/A';
        })()}
        subtitle={overviewData.period}
        icon={<ScheduleIcon sx={{ fontSize: 36 }} />}
        color="secondary"
      />
    </Box>
  );
};

export default OverviewMetrics;
